import { styled } from '@linaria/react';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 20px;
	height: 20px;
	color: var(--color-white);
	background-color: var(--brand-common);
	border-radius: 100%;
	box-shadow: var(--shadow-black);
`;
